import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { useIntl } from 'react-intl';
import RichText from '../UI/RichText';
import CallToActionCard from '../CallToActionCard/CallToActionCard';

import { CombinatorSectionItem, Heading } from '../../ContentfulTypes';
import { CardsContainer, CardsHeading } from './styles';

const sectionHeadingOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <CardsHeading>{children}</CardsHeading>
    ),
    [BLOCKS.HEADING_1]: (_, children) => (
      <CardsHeading data-testid="mobile-shop-cards-heading">
        {children}
      </CardsHeading>
    ),
    [BLOCKS.HEADING_2]: (_, children) => (
      <CardsHeading data-testid="mobile-shop-cards-heading">
        {children}
      </CardsHeading>
    ),
    [BLOCKS.HEADING_3]: (_, children) => (
      <CardsHeading>{children}</CardsHeading>
    ),
  },
};

interface Props {
  heading: Heading;
  cards: Array<CombinatorSectionItem>;
  bladeData: Array<CombinatorSectionItem>;
  backgroundImages?: Array<CombinatorSectionItem>;
}
const MobileShopCards = ({
  heading,
  cards,
  bladeData,
  backgroundImages = [],
}: Props) => {
  const { locale } = useIntl();

  return (
    <CardsContainer data-testid="mobile-shop-cards-container">
      <RichText document={heading} options={sectionHeadingOptions} />
      {cards.map((card, index) => (
        <CallToActionCard
          locale={locale}
          cardData={card}
          bladeData={bladeData[index]}
          backgroundImageData={backgroundImages[index]}
          key={card.contentful_id}
          section="Card Section"
        />
      ))}
    </CardsContainer>
  );
};

export default MobileShopCards;
